"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
function refreshAuthToken(refreshToken) {
    const url = "https://gloow.eu.auth0.com/oauth/token";
    const params = {
        client_id: 'Ya3fXVlZYEu1PTjvlFYzZZzMPYfCPAwq',
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
        scope: 'openid profile email offline_access read:current_user update:current_user_metadata'
    };
    return axios_1.default({
        method: 'post',
        url,
        data: Object.assign({}, params)
    }).then(result => {
        return result.data;
    }).catch(err => {
        console.log("axios refresh token error");
        console.log(err);
    });
}
exports.default = refreshAuthToken;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aDAuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcHJpdmF0ZS91dGlscy9hdXRoMC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGlDQUEwQjtBQUUxQixTQUF3QixnQkFBZ0IsQ0FBQyxZQUFZO0lBQ2pELE1BQU0sR0FBRyxHQUFHLHdDQUF3QyxDQUFDO0lBRXJELE1BQU0sTUFBTSxHQUFHO1FBQ2IsU0FBUyxFQUFFLGtDQUFrQztRQUM3QyxVQUFVLEVBQUUsZUFBZTtRQUMzQixhQUFhLEVBQUUsWUFBWTtRQUMzQixLQUFLLEVBQUUsb0ZBQW9GO0tBQzVGLENBQUE7SUFFRCxPQUFPLGVBQUssQ0FBQztRQUNYLE1BQU0sRUFBRSxNQUFNO1FBQ2QsR0FBRztRQUNILElBQUksb0JBQ0MsTUFBTSxDQUNWO0tBQ0YsQ0FBQyxDQUFDLElBQUksQ0FBRSxNQUFNLENBQUMsRUFBRTtRQUNoQixPQUFPLE1BQU0sQ0FBQyxJQUFJLENBQUM7SUFDckIsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxFQUFFO1FBQ2IsT0FBTyxDQUFDLEdBQUcsQ0FBRSwyQkFBMkIsQ0FBRSxDQUFDO1FBQzNDLE9BQU8sQ0FBQyxHQUFHLENBQUUsR0FBRyxDQUFFLENBQUM7SUFDckIsQ0FBQyxDQUFDLENBQUE7QUFDTixDQUFDO0FBdEJELG1DQXNCQyJ9